import { NgModule } from '@angular/core';
import { SyncService } from './sync.service';

@NgModule({
  providers: [SyncService]
})
export class SyncModule { }
